module.exports = __webpack_public_path__ + "img/boss-bd-2-blues-driver.3880a1c8.jpg";